<ng-container *transloco="let t">
  <div class="flex h-full min-h-0 flex-col overflow-hidden pt-3">
    @if (!isStoreSpotlight()) {
      <div class="flex items-start justify-between border-b pr-3">
        <ITabsSelector class="shrink-0 px-2" [(value)]="selectedCreativeId">
          @for (creative of creatives(); track creative.id) {
            <button iTab [value]="creative.id">
              @if (creative.invalid) {
                <IIcon name="alertTriangle" class="text-destructive size-3.5 shrink-0" />
              }
              <span [class.text-destructive]="creative.invalid">{{ creative.label }}</span>
            </button>
          }
          @if (!isVideoCreative()) {
            <button
              iButton
              type="button"
              variant="ghost"
              size="icon-sm"
              class="ml-2 border border-dashed"
              [iTooltip]="canAddCreative() ? t('sb-form-creative.add_creative') : undefined"
              iTooltipPlacement="right-center"
              [disabled]="!canAddCreative()"
              (click)="addCreative()"
            >
              <IIcon name="plus" />
            </button>
          }
        </ITabsSelector>

        <div class="flex items-center gap-2">
          @if (selectedCreativeId() > 0) {
            <button iButton variant="secondary" (click)="deleteCreative()">
              <IIcon name="trash" />
              {{ t("sb-form-creative.delete_creative", [selectedCreative().label]) }}
            </button>
          }
        </div>
      </div>

      <div class="flex w-full gap-3 border-b px-4 py-3">
        <div>
          {{
            t("sb-form-asins.asins_selected", {
              selected: selectedAsins().length | number: "1.0-0" : locale(),
              max: asinsLimit().max | number: "1.0-0" : locale(),
            })
          }}
          <span class="text-muted-foreground">
            {{
              t("sb-form-asins.asins_bounds", {
                min: asinsLimit().min | number: "1.0-0" : locale(),
                max: asinsLimit().max | number: "1.0-0" : locale(),
              })
            }}
          </span>
        </div>

        <div>
          @if (selectedCreativeErrorMessage(); as errorKey) {
            <div class="text-destructive">{{ t(errorKey) }}</div>
          } @else if (showSameParentWarning()) {
            <div class="text-warning">{{ t("sb-form-asins.same_parent_asin_warning") }}</div>
          }
        </div>
      </div>
    }

    <app-form-preview-split class="min-h-0 flex-1">
      <div splitMain class="h-full min-h-0 overflow-hidden">
        @if (isStoreSpotlight()) {
          <div class="h-full min-h-0 overflow-y-auto p-3">
            <app-store-spotlight-pages
              [marketplace]="marketplace()"
              [storePages]="spotlightStorePages()"
              [existingSbAsins]="existingSpotlightSbAsins()"
              (emitSbAsins)="onSpotlightSbAsinsChange($event)"
            />
          </div>
        } @else {
          <app-asin-selection
            class="block h-full w-full"
            [csvExport]="false"
            [bordered]="false"
            ineligibilityTag="SB"
            [asinsLimit]="asinsLimit().max"
            [customList]="asinCustomList()"
            [selectedAsins]="selectedAsins()"
            (selectedAsinsChange)="onSelectedAsinsChange($event)"
          />
        }
      </div>
      <app-creative-preview-list
        splitPreview
        class="block h-full min-h-0"
        [creativeSbAsins]="creativesSbAsins().sbAsins().value()"
        [selectedCreativeId]="selectedCreativeId()"
        [creativeType]="creativeType()"
        [brandName]="assets().brandName().value()"
        [headline]="assets().headline().value()"
        [brandLogoUrl]="assets().brandLogo().value()?.url"
        [videoUrl]="assets().video().value()?.url"
      />
    </app-form-preview-split>
  </div>
</ng-container>
